// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"detail_wrapper__MczJ2","wrapper_inside":"detail_wrapper_inside__15t3Z","item":"detail_item__Z8V6L"};